import Tooltip, { TooltipTrigger } from '@/components/atoms/Tooltip';

import styles from './PenComparisonTable.module.scss';

interface PenBandFigureProps {
    figure: string;
    /** The band's explanation, which the tooltip shows. */
    title: string;
}

/**
 * The figure of a cell a settings band marks. The band is the only account of the colour,
 * so a keyboard or touch user reaches it the way a pointer does, as with the pen tags: the
 * figure is a button whose focus opens the tooltip, and pressing it does nothing more. An
 * unmarked cell keeps a plain title, so the table gains a tab stop only where a colour needs
 * explaining.
 */
export function PenBandFigure(props: PenBandFigureProps) {
    const { figure, title } = props;
    // The shared tooltip portals the bubble into the body, so the table's scroll region neither
    // clips it nor grows around it.
    return (
        <Tooltip content={title} layout="fit" targetClassName={styles.bandTarget}>
            <TooltipTrigger description={title}>{figure}</TooltipTrigger>
        </Tooltip>
    );
}
